// ** Initial State
const initialState = {
  employees: [],
  total: 1,
  params: {},
  selectedEmployee: null,
  pending: false,
};

const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "EMPLOYEE/GETALL":
      return {
        ...state,
        employees: action.employees,
        total: action.totalPages,
        params: action.params,
      };
    case "EMPLOYEE/ADD":
      return { ...state };
    case "EMPLOYEE/DELETE":
      return { ...state };
    case "EMPLOYEE/GET":
      return { ...state, selectedEmployee: action.selectedEmployee };
    case "EMPLOYEE/PENDING":
      return { ...state, pending: action.status };
    default:
      return { ...state };
  }
};

export default employeeReducer;
